import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ViewDocxService} from '../../../services/view-docx.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-view-docx',
  templateUrl: './view-docx.component.html',
  styleUrls: ['./view-docx.component.css']
})
export class ViewDocxComponent implements OnInit {
  isLoaded = false;
  viewSrc = '';
  tempDocLink = '';


  constructor(public activeModal: NgbActiveModal,
              public sanitizer: DomSanitizer,
              public viewDocxService: ViewDocxService) {
  }

  ngOnInit() {
    this.isLoaded = false;
    if (localStorage.getItem('fileLink')) {
      this.setFileLink(localStorage.getItem('fileLink'));
    } else {
      this.getFileLink();
    }
  }

  getFileLink() {
    const linkRequest: Observable<any> = this.viewDocxService.getLinkByDocxID();
    if (!linkRequest) {
      this.viewDocxService.clearTempFileLoacalStorage();
      this.setFileLink('no_file.docx');
      return;
    }
    linkRequest.subscribe(
      (res: any) => {
        this.tempDocLink = res.body;
        this.setFileLink(this.tempDocLink);
      },
      (err) => {
        this.viewDocxService.clearTempFileLoacalStorage();
        this.setFileLink('no_file.docx');
      }
    );
  }

  setFileLink(fileURL: string) {
    this.viewSrc = 'https://view.officeapps.live.com/op/view.aspx?src=' + fileURL;
    this.isLoaded = true;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-docx/view-docx.component.ts